module.exports = __webpack_public_path__ + "img/android-icon-72x72.f6bc4af.png";